import {createApi} from '@reduxjs/toolkit/query/react';
import professionalCategoryEndpoints , {type as professionalCategoryType} from "./professionalCategoryEndpoints";
import transportFacilityEndpoints, {type as transportFacilityType} from "./transportFacilityEndpoints";
import allowanceSettingsEndpoints, {type as allowanceType} from "./allowanceSettingsEndpoints";
import beneficiaryEndpoints, {type as beneficiaryType} from "./beneficiaryEndpoints";
import companyEndpoints, {type as companyType} from "./companyEndpoints";
import userEndpoints, {type as userType} from "./userEndpoints";
import {axiosBaseQuery} from "./utils/axios-base-query";
import {API_ENDPOINT_TRANSPORT} from "../../config/settings";


export const api = createApi({
  reducerPath: 'transportAPI',
  baseQuery: axiosBaseQuery({ baseUrl: API_ENDPOINT_TRANSPORT }),
  tagTypes: [allowanceType, beneficiaryType, professionalCategoryType, transportFacilityType, companyType, userType],
  keepUnusedDataFor: 30,
  endpoints: (builder) => ({
    ...professionalCategoryEndpoints(builder),
    ...allowanceSettingsEndpoints(builder),
    ...transportFacilityEndpoints(builder),
    ...beneficiaryEndpoints(builder),
    ...companyEndpoints(builder),
    ...userEndpoints(builder),
  })
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  // Professional Category
  useRemoveProfessionalCategoryMutation,
  usePutProfessionalCategoryMutation,
  useGetProfessionalCategoriesQuery,
  useGetProfessionalCategoryQuery,
  useGetEmployeeSubGroupsQuery,

  // Allowance Settings
  useRemoveAllowanceDefinitionMutation,
  usePutAllowanceDefinitionMutation,
  useGetAllowanceDefinitionsQuery,
  useGetAllowanceDefinitionQuery,

  // Transport Facility
  usePutTransportFacilityRequestPerEmployeeMutation,
  useGetTransportFacilitiesPerBeneficiaryQuery,
  useGetTransportFacilitiesPerEmployeeMutation,
  useGetTransportFacilitiesUsagesPerEmployeeQuery,
  usePutTransportFacilityRequestMutation,
  useGetTransportFacilitiesMotivesQuery,
  useConsumeAuthorizationMutation,
  useRefundAuthorizationMutation,
  useCancelAuthorizationMutation,
  useGetAuthorizationsQuery,


  // Beneficiary
  useRemoveBeneficiaryMutation,
  usePutBeneficiaryMutation,
  useGetBeneficiariesQuery,
  useGetBeneficiaryQuery,

  // Company
  useGetCompaniesQuery,

  // User
  useGetCurrentUserFacilitiesQuery,
  useGetUsersQuery,
  useGetCurrentSelectedUserQuery,

  endpoints
} = api;

export default api;
